import * as React from 'react';
import { useSelector } from 'react-redux';
import { MESSAGE_TYPES } from '../../../../src/shared/constants';
import { getChatSettings, getIsChatRendered } from '../../selectors/chat';
import { getChatMessages } from '../../selectors/messages';

const audio = new Audio('https://spa-packages.siteground.com/chat/beep1.mp3');

export const NewMessageSound = () => {
  const { sound } = useSelector(getChatSettings);
  const isChatRendered = useSelector(getIsChatRendered);
  const messages = useSelector(getChatMessages);
  const prevMessages = React.useRef([]);

  React.useEffect(() => {
    const prevMessagesToUse = prevMessages.current;

    if (prevMessagesToUse.length === 0) {
      prevMessages.current = [].concat(messages);
      return;
    }

    if (prevMessagesToUse.length === messages.length) {
      return;
    }

    const messagesThatNeedSound = messages
      .slice(messages.length - Math.max(messages.length - prevMessagesToUse.length, 1))
      .filter(({ messageType }) => messageType !== MESSAGE_TYPES.FROM_USER);

    const shouldPlaySound = messagesThatNeedSound.length && sound && isChatRendered;

    if (shouldPlaySound && audio) {
      try {
        audio.play();
      } catch (e) {
        console.warn(e);
      }
    }

    prevMessages.current = [].concat(messages);
  }, [messages]);

  return null;
};

export default NewMessageSound;
